// Μοναδικό σημείο πρόσβασης στη συνεδρία. Η ανάγνωση δεν πετά ποτέ: όταν το κλειδί
// λείπει ή το περιεχόμενο είναι κατεστραμμένο, επιστρέφεται null και ο καλών
// αντιμετωπίζει τον χρήστη ως μη συνδεδεμένο.
const KEY = 'userCredentials';

export function getSession() {
    try {
        const raw = localStorage.getItem(KEY);
        if (!raw) return null;

        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== 'object' || !parsed.token) return null;

        return parsed;
    } catch {
        return null;
    }
}

export function getToken() {
    return getSession()?.token ?? null;
}

export function getUser() {
    return getSession()?.user ?? null;
}

/**
 * Ανανεώνει **μόνο** τα πεδία του χρήστη που άλλαξαν, κρατώντας το διακριτικό.
 *
 * ⚠ **Υπάρχει για τον καθολικό ρόλο, και είναι το αντίστροφο της D39.** Ο
 * εξυπηρετητής διαβάζει τη σημαία **ζωντανά**· ο πελάτης τη διάβαζε από το
 * διακριτικό, που ζει επτά ημέρες. Αποτέλεσμα: μενού και κουμπιά που υπόσχονταν
 * ενέργειες τις οποίες ο εξυπηρετητής αρνιόταν.
 *
 * **Γράφει μόνο όταν κάτι άλλαξε.** Η περιοδική ανάκτηση τρέχει ανά δέκα
 * δευτερόλεπτα· εγγραφή σε κάθε κύκλο θα ήταν θόρυβος χωρίς αντίκρισμα, και θα
 * έκανε την αποθήκευση σημείο συνεχούς μεταβολής χωρίς λόγο.
 *
 * @returns `true` αν κάτι πράγματι άλλαξε — ο καλών το χρειάζεται για να
 *   αποδώσει ξανά.
 */
export function refreshSessionUser(changes) {
    const current = getSession();
    if (!current?.user) return false;

    // **Το `undefined` δεν είναι τιμή, είναι απουσία.** Χωρίς αυτό, μερική
    // απάντηση θα έγραφε `undefined` πάνω από τον καθολικό ρόλο — δηλαδή θα
    // υποβίβαζε τον διαχειριστή από **σφάλμα μορφής**, σιωπηλά.
    const changed = Object.entries(changes)
        .filter(([, value]) => value !== undefined)
        .filter(([key, value]) => current.user[key] !== value);
    if (changed.length === 0) return false;

    localStorage.setItem(KEY, JSON.stringify({
        ...current,
        user: { ...current.user, ...Object.fromEntries(changed) }
    }));

    return true;
}

export function setSession(token, user) {
    localStorage.setItem(KEY, JSON.stringify({ token, user }));
}

export function clearSession() {
    localStorage.removeItem(KEY);
}

export function isAuthenticated() {
    return Boolean(getToken());
}
